<template>
  <div class="navigation">
    <!-- DeepSea Desktop Navigation -->
    <nav class="deepsea-nav" v-if="deepsea">
      <!-- DeepSea MegaMenu START-->
      <ul>
        <!-- About - START -->
        <li
          class="dropdown"
          @mouseenter="showAboutDropdown = true"
          @mouseleave="showAboutDropdown = false"
        >
          <div class="dropdown-li">
            <a href="#">
              <span>About</span>
              <span class="dropdown-icon">
                <BaseIcon :iconName="dropdown" :width="10" :height="10">
                  <IconDropdown />
                </BaseIcon>
              </span>
            </a>
          </div>
          <!-- About - Dropdown Submenu START -->
          <transition name="slide-down">
            <ul
              class="deepsea-dropdown-links deepsea-submenu"
              v-if="showAboutDropdown"
            >
              <div class="deepsea-submenu-content">
                <div class="deepsea-submenu-title">About</div>
                <div class="deepsea-submenu-col-wrapper">
                  <div class="deepsea-submenu-col-1">
                    <ul>
                      <div class="deepsea-submenu-tagline">
                        The DeepSea Mission
                      </div>
                      <li class="deepsea-submenu-subtitle">
                        <a href="https://www.deepsea.com/our-history/"
                          >Our History</a
                        >
                      </li>
                    </ul>
                    <ul>
                      <div class="deepsea-submenu-tagline">
                        Job Opportunities
                      </div>
                      <li class="deepsea-submenu-subtitle">
                        <a href="https://careers.seescan.com/deepsea"
                          >Careers</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="deepsea-submenu-col-2">
                    <div class="deepsea-submenu-col-2-group">
                      <div class="deepsea-submenu-col-group-title">
                        Our Company
                      </div>
                      <ul>
                        <li>
                          <a href="https://www.deepsea.com/about-us/"
                            >About Us</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/life-at-deepsea/"
                            >Life at DeepSea</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/the-deepsea-difference/"
                            >The DeepSea Difference</a
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="deepsea-submenu-col-2-group">
                      <div class="deepsea-submenu-col-group-title">
                        Our Products
                      </div>
                      <ul>
                        <li>
                          <a href="https://www.deepsea.com/our-patents/"
                            >Intellectual Property</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/terms-and-conditions/"
                            >Terms and Conditions</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/warranty/"
                            >Warranty</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </transition>
          <!-- About - Dropdown Submenu END -->
        </li>
        <!-- About - END -->

        <!-- Products - START -->
        <li
          class="dropdown"
          @mouseenter="showProductsDropdown = true"
          @mouseleave="showProductsDropdown = false"
        >
          <div class="dropdown-li">
            <a href="#">
              <span>Products</span>
              <span class="dropdown-icon">
                <BaseIcon :iconName="dropdown" :width="10" :height="10">
                  <IconDropdown />
                </BaseIcon>
              </span>
            </a>
          </div>
          <!-- Products - Dropdown Submenu START -->
          <transition name="slide-down">
            <ul
              class="deepsea-dropdown-links deepsea-submenu"
              v-if="showProductsDropdown"
            >
              <div class="deepsea-submenu-content">
                <div class="deepsea-submenu-title">Products</div>
                <div class="deepsea-submenu-col-wrapper">
                  <div class="deepsea-submenu-col-1">
                    <ul>
                      <div class="deepsea-submenu-tagline">
                        STANDARDIZED BUILDS ON DEMAND
                      </div>
                      <li class="deepsea-submenu-subtitle">
                        <a href="https://www.deepsea.com/quickship/"
                          >Product Configurations</a
                        >
                      </li>
                      <li>
                        <a href="https://www.deepsea.com/quickship/#quickship"
                          >QuickShip Products</a
                        >
                      </li>
                      <li>
                        <a
                          href="https://www.deepsea.com/quickship/#preconfigured"
                          >Pre-Configured Products</a
                        >
                      </li>
                    </ul>
                    <ul>
                      <li class="deepsea-submenu-subtitle">
                        <a href="https://www.deepsea.com/product-documentation/"
                          >Product Documentation</a
                        >
                      </li>
                    </ul>
                    <ul>
                      <li class="deepsea-submenu-subtitle">
                        <a href="https://www.deepsea.com/faqs/">Product FAQs</a>
                      </li>
                    </ul>
                    <ul>
                      <div class="deepsea-submenu-col-group-title">
                        Services
                      </div>
                      <li>
                        <a
                          href="https://www.deepsea.com/our-services/#optical-measurement"
                          >Optical Measurement</a
                        >
                      </li>
                      <li>
                        <a href="https://www.deepsea.com/our-services"
                          >Pressure Testing</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="deepsea-submenu-col-2">
                    <div class="deepsea-submenu-col-2-group">
                      <div class="deepsea-submenu-col-group-title">Cameras</div>
                      <ul>
                        <li>
                          <a href="https://www.deepsea.com/cameras/"
                            >All Cameras</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/smartsight-mv100/"
                            >SmartSight® MV100</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/cameras/mxd-seacam/"
                            >MxD® SeaCam®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/optim-seacam/"
                            >Optim SeaCam®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/vertex-seacam/"
                            >Vertex™ SeaCam®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/hd-multi-seacam/"
                            >HD Multi SeaCam®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/hd-zoom-seacam/"
                            >HD Zoom SeaCam®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/super-wide-i-seacam/"
                            >Super Wide-i SeaCam®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/wide-i-seacam/"
                            >Wide-i SeaCam®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/multi-seacam/"
                            >Multi SeaCam®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/cameras/led-multi-seacam/"
                            >LED Multi SeaCam®</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/cameras/nano-seacam/"
                            >Nano SeaCam®</a
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="deepsea-submenu-col-2-group">
                      <div class="deepsea-submenu-col-group-title">Lights</div>
                      <ul>
                        <li>
                          <a href="https://www.deepsea.com/lights/"
                            >All Lights</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/lights/led-sealite/"
                            >LED SeaLite®</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/lights/sealite-sphere/"
                            >SeaLite Sphere®</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/lights/nano-sealite/"
                            >Nano SeaLite®</a
                          >
                        </li>
                      </ul>
                      <br />
                      <div class="deepsea-submenu-col-group-title">Lasers</div>
                      <ul>
                        <li>
                          <a href="https://www.deepsea.com/lasers/"
                            >All Lasers</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/lasers/micro-sealaser/"
                            >Micro SeaLaser®</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/lasers/sealaser-100/"
                            >SeaLaser® 100</a
                          >
                        </li>
                      </ul>
                      <br />
                      <div class="deepsea-submenu-col-group-title">Power</div>
                      <ul>
                        <li>
                          <a
                            href="https://www.deepsea.com/batteries/seabattery-power-module/"
                            >SeaBattery®</a
                          >
                        </li>
                      </ul>
                    </div>
                    <div class="deepsea-submenu-col-2">
                      <div class="deepsea-submenu-col-2-group">
                        <div class="deepsea-submenu-col-group-title">
                          Relief Valves
                        </div>
                        <ul>
                          <li>
                            <a href="https://www.deepsea.com/vents/"
                              >All Relief Valves</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://www.deepsea.com/vents/double-dual-seal/"
                              >Double Dual Seal</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://www.deepsea.com/vents/single-dual-seal/"
                              >Single Dual Seal</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://www.deepsea.com/vents/single-seal-sae/"
                              >Single Seal SAE</a
                            >
                          </li>
                        </ul>
                        <br />
                        <div class="deepsea-submenu-col-group-title">
                          Multiplexor
                        </div>
                        <ul>
                          <li>
                            <a
                              href="https://www.deepsea.com/multiplexer/smarthub/"
                              >SmartHub™</a
                            >
                          </li>
                        </ul>
                        <br />
                        <div class="deepsea-submenu-col-group-title">
                          Accessories
                        </div>
                        <ul>
                          <li>
                            <a
                              href="https://www.deepsea.com/accessories/brackets/"
                              >Brackets</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="deepsea-submenu-col-2">
                      <div class="deepsea-submenu-col-2-group">
                        <div class="deepsea-submenu-col-group-title">
                          Technology
                        </div>
                        <ul>
                          <li>
                            <a href="https://www.deepsea.com/technology/"
                              >All Technology</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://www.deepsea.com/accessories/multiray-led-sealite/"
                              >Multiray® LED SeaLite®</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://www.deepsea.com/accessories/flexlink/"
                              >FleXlink®</a
                            >
                          </li>
                          <li>
                            <a
                              href="https://www.deepsea.com/accessories/seasense-protocol/"
                              >SeaSense® Protocol</a
                            >
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </transition>
          <!-- Products - Dropdown Submenu END -->
        </li>
        <!-- Products - END -->

        <!-- News - START -->
        <li
          class="dropdown"
          @mouseenter="showNewsDropdown = true"
          @mouseleave="showNewsDropdown = false"
        >
          <div class="dropdown-li">
            <a href="#">
              <span>News</span>
              <span class="dropdown-icon">
                <BaseIcon :iconName="dropdown" :width="10" :height="10">
                  <IconDropdown />
                </BaseIcon>
              </span>
            </a>
          </div>
          <!-- News - Dropdown Submenu START -->
          <transition name="slide-down">
            <ul
              class="deepsea-dropdown-links deepsea-submenu"
              v-if="showNewsDropdown"
            >
              <div class="deepsea-submenu-content">
                <div class="deepsea-submenu-title">News</div>
                <div class="deepsea-submenu-col-wrapper">
                  <div class="deepsea-submenu-col-1">
                    <ul>
                      <div class="deepsea-submenu-tagline">
                        LIVE AT LA JOLLA SHORES, SAN DIEGO
                      </div>
                      <li class="deepsea-submenu-subtitle">
                        <a href="https://www.deepsea.com/sio-piercam/"
                          >Scripps Pier Livestream</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="deepsea-submenu-col-2">
                    <div class="deepsea-submenu-col-2-group">
                      <div class="deepsea-submenu-col-group-title">
                        Announcements
                      </div>
                      <ul>
                        <li>
                          <a href="https://www.deepsea.com/whats-new/"
                            >What's New</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/trade-shows/"
                            >Trade Shows</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/press-releases/"
                            >Press Releases</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/product-change-notices/"
                            >Product Change Notices</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </transition>
          <!-- News - Dropdown Submenu END -->
        </li>
        <!-- News - END -->

        <!-- Support - START -->
        <li
          class="dropdown"
          @mouseenter="showSupportDropdown = true"
          @mouseleave="showSupportDropdown = false"
        >
          <div class="dropdown-li">
            <a href="#">
              <span>Support</span>
              <span class="dropdown-icon">
                <BaseIcon :iconName="dropdown" :width="10" :height="10">
                  <IconDropdown />
                </BaseIcon>
              </span>
            </a>
          </div>
          <!-- Support - Dropdown Submenu START -->
          <transition name="slide-down">
            <ul
              class="deepsea-dropdown-links deepsea-submenu"
              v-if="showSupportDropdown"
            >
              <div class="deepsea-submenu-content">
                <div class="deepsea-submenu-title">Support</div>
                <div class="deepsea-submenu-col-wrapper">
                  <div class="deepsea-submenu-col-1">
                    <ul>
                      <li class="deepsea-submenu-subtitle">
                        <a href="https://www.deepsea.com/contact/"
                          >Contact Us</a
                        >
                      </li>
                      <br />
                      <br />
                      <li class="deepsea-submenu-subtitle">
                        <a href="https://www.deepsea.com/product-documentation/"
                          >Product Documentation</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="deepsea-submenu-col-2">
                    <div class="deepsea-submenu-col-2-group">
                      <div class="deepsea-submenu-col-group-title">
                        Knowledgebase
                      </div>
                      <ul>
                        <li>
                          <a href="https://www.deepsea.com/knowledgebase/"
                            >All Articles</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/knowledgebase/underwater-imaging/"
                            >Underwater Imaging</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/knowledgebase/underwater-lighting/"
                            >Underwater Lighting</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/knowledgebase/technical-resources/"
                            >Technical Resources</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/knowledgebase/products-in-use/"
                            >Products In Use</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/knowledgebase/design-tools/"
                            >Design Tools</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/knowledgebase/pressure-testing/"
                            >Pressure Testing</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="deepsea-submenu-col-2">
                    <div class="deepsea-submenu-col-2-group">
                      <div class="deepsea-submenu-col-group-title">
                        Support and Sales
                      </div>
                      <ul>
                        <li>
                          <a href="https://help.deepsea.com/support/home"
                            >Online Product Support</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://www.deepsea.com/return-material-authorization/"
                            >Return Material Authorization</a
                          >
                        </li>
                        <li>
                          <a href="https://www.deepsea.com/our-representatives/"
                            >Our Representatives</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </ul>
          </transition>
          <!-- Support - Dropdown Submenu END -->
        </li>
        <!-- Support - END -->
        <!-- Request a Quote -->
        <li>
          <button class="quote-btn">
            <a href="https://www.deepsea.com/contact/">Request a Quote</a>
          </button>
        </li>
      </ul>
    </nav>
    <!-- SeeScan Desktop Navigation -->
    <nav class="seescan-nav" v-else>
      <ul>
        <!-- SeeScan Home -->
        <li>
          <a href="http://www.seescan.com">Home</a>
        </li>
        <!-- Our Company - Dropdown -->
        <li
          class="dropdown"
          @mouseenter="showCoDropdown = !showCoDropdown"
          @mouseleave="showCoDropdown = !showCoDropdown"
        >
          <div class="dropdown-li">
            <a href="#">
              <span>Our Company</span>
              <span class="dropdown-icon">
                <BaseIcon :iconName="dropdown" :width="10" :height="10">
                  <IconDropdown />
                </BaseIcon>
              </span>
            </a>
          </div>
          <!-- Our Company - Dropdown Submenu -->
          <ul class="dropdown-links seescan-submenu" v-if="showCoDropdown">
            <li>
              <a href="https://www.seescan.com/about-us/"> About Us </a>
            </li>
            <li>
              <a href="https://www.seescan.com/our-history/"> Our History </a>
            </li>
            <li>
              <a href="https://www.seescan.com/our-campus/"> Our Campus </a>
            </li>
            <li>
              <a href="https://www.seescan.com/terms-and-conditions/">
                Terms &amp; Conditions
              </a>
            </li>
            <li>
              <a href="https://www.seescan.com/intellectual-property/">
                Intellectual Property
              </a>
            </li>
            <li>
              <a href="https://www.seescan.com/covid-19/"> COVID-19 </a>
            </li>
          </ul>
        </li>
        <!-- Seescan Careers - Dropdown -->
        <li
          class="dropdown"
          @mouseenter="showCareersDropdown = !showCareersDropdown"
          @mouseleave="showCareersDropdown = !showCareersDropdown"
        >
          <div class="dropdown-li">
            <a href="#" class="active">
              <span>Careers</span>
              <span class="dropdown-icon">
                <BaseIcon :iconName="dropdown" :width="10" :height="10">
                  <IconDropdown />
                </BaseIcon>
              </span>
            </a>
          </div>
          <!-- Seescan Careers - Dropdown Submenu -->
          <ul class="dropdown-links seescan-submenu" v-if="showCareersDropdown">
            <li>
              <a href="https://www.seescan.com/life-at-seescan/">
                Life at SeeScan
              </a>
            </li>
            <li>
              <router-link to="/" :active="isActive" @click="setFavicon"
                >Job Opportunities</router-link
              >
            </li>
          </ul>
        </li>
        <!-- SeeScan Knowledgebase -->
        <li>
          <a href="https://www.seescan.com/knowledgebase/">Knowledgebase</a>
        </li>
        <!-- SeeScan Geo Locating -->
        <li>
          <a href="https://www.seescan.com/geo-locating/">Geo Locating</a>
        </li>
        <!-- SeeScan Our Products -->
        <li><a href="https://www.seescan.com/products/">Our Products</a></li>
        <!-- SeeScan Repair -->
        <li><a href="https://www.seescan.com/repair/">Repair</a></li>
        <!-- SeeScan Contact Us -->
        <li><a href="https://www.seescan.com/contact_us/">Contact Us</a></li>
      </ul>
    </nav>
  </div>
</template>

<script>
import BaseIcon from './global/BaseIcon.vue'
import IconDropdown from './icons/IconDropdown.vue'
// import Search from './Search.vue'
import { directive } from 'vue3-click-away'

export default {
  name: 'Desktop Navigation',
  components: {
    BaseIcon,
    IconDropdown,
    // Search,
  },
  props: {
    deepsea: {
      type: Boolean,
    },
  },
  data() {
    return {
      // isVisible: false,
      showAboutDropdown: false,
      showCareersDropdown: false,
      showCoDropdown: false,
      showContactDropdown: false,
      showKnowledgebaseDropdown: false,
      showNewsDropdown: false,
      showProductsDropdown: false,
      showSearch: false,
      showSupportDropdown: false,
    }
  },
  directives: {
    ClickAway: directive,
  },
  methods: {
    setFavicon() {
      const favicon = document.querySelector("[rel='icon']")
      favicon.setAttribute('href', this.$route.meta.icon)
    },
    onClickAway(event) {
      console.log(event)
      this.showSearch = false
    },
    // toggle() {
    //   this.isVisible = !this.isVisible;
    // }
  },
}
</script>

<style scoped>
/* Request a Quote Button */
.quote-btn a {
  border: 2px solid #ffda00;
  border-radius: 0;
  color: #ffda00;
  cursor: pointer;
  font-weight: bold;
  height: 48px;
  padding: 10px 20px;
  transition: background-color 0.4s ease, transform 0.4s ease;
}

.quote-btn a:hover {
  background: #ffda00;
  border-radius: 2px;
  color: #0956a1;
  transform: scale(1.05);
}

/* Slide-Down Transition START */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-24px);
}

.slide-down-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.slide-down-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

/* Slide-Down Transition END */

nav {
  align-items: flex-end;
}

nav ul {
  margin: 0;
}

nav ul li {
  display: inline-flex;
  padding: 0 24px 0 0;
  cursor: pointer;
}

nav ul li.search {
  padding-left: 16px;
  padding-right: 0;
  vertical-align: -2.5px;
}

nav ul li a#search-icon {
  border-color: transparent;
  height: 105px;
}

nav ul li a {
  color: white;
  font-size: 1em;
  text-decoration: none;
  box-sizing: border-box;
  height: 110px;

  display: flex;
  align-items: center;
  line-height: 1;
}

nav.seescan-nav ul li a:hover,
nav.seescan-nav ul li a:active,
nav.seescan-nav ul li a.active {
  color: #5bba47;
  border-top-color: #5bba47;
  border-top-width: 4px;
  border-top-style: solid;
}

nav.deepsea-nav ul li div.dropdown-li a:hover,
nav.deepsea-nav ul li div.dropdown-li a:active,
nav.deepsea-nav ul li div.dropdown-li a.active,
nav.deepsea-nav ul li:hover div.dropdown-li a .dropdown-icon {
  color: #ffda00;
}

/* dropdown */
nav ul li.dropdown div.dropdown-li {
  display: flex;
  flex-basis: auto;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.dropdown-icon {
  color: #f2f2f2;
  display: flex;
  padding-left: 8px;
}

nav.seescan-nav ul li:hover .dropdown-icon,
nav.seescan-nav ul li:hover .dropdown-icon:hover {
  color: #5bba47;
}

nav ul li:hover .dropdown-icon,
nav ul li:hover .dropdown-icon:hover {
  background: transparent;
  border: none;
}

ul.deepsea-submenu {
  background: #e8e8e8;
  padding: 30px 100px;
  border-bottom: 20px solid transparent;
  border-image: linear-gradient(90deg, #0956a1 0%, #39d52d 100%) 1;
}

ul.deepsea-submenu .deepsea-submenu-content {
  max-width: 1400px;
  margin: 0 auto;
  /* center content */
  width: 100%;
}

.deepsea-submenu-col-wrapper ul div div:hover,
.deepsea-submenu-col-wrapper ul div li a:hover {
  transition: transform 0.4s ease;
}

ul.seescan-submenu {
  background: black;
  border-top: #5bba47 2px solid;
}

ul.deepsea-submenu .deepsea-submenu-title {
  color: black;
  font-size: 24px;
  font-weight: 700;
  padding: 0 0 16px 0;
  text-align: left;
  border-bottom: #0956a1 1px solid;
}

.deepsea-submenu-col-wrapper {
  display: flex;
  flex-direction: row;
  gap: 24px;
  text-align: left;
  color: black;
  padding: 24px 0px;
}

.deepsea-submenu-col-1 {
  width: 350px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.deepsea-submenu-col-1 ul li a {
  height: unset;
}

.deepsea-submenu-col-2 {
  display: flex;
  flex-direction: row;
  gap: auto;
}

.deepsea-submenu-col-2-group {
  display: flex;
  flex-direction: column;
}

.deepsea-submenu-col-group-title {
  color: black;
  font-size: 22px;
  font-weight: bold;
  text-transform: capitalize;
  padding-bottom: 8px;
}

.deepsea-submenu-col-2-group ul {
  display: flex;
  flex-direction: column;
}

.deepsea-submenu-col-2-group ul li a {
  height: 1.6rem;
  min-width: 210px;
}

.deepsea-submenu-col-wrapper .deepsea-submenu-tagline {
  color: #0956a1;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  padding-bottom: 8px;
}

.deepsea-submenu-col-wrapper .deepsea-submenu-subtitle a {
  color: #192b6c;
  font-size: 24px;
  font-weight: 600;
}

ul.deepsea-dropdown-links {
  position: absolute;
  top: 110px;
  left: 0;
  width: 100%;
  z-index: 999;
}

ul.dropdown-links {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  position: absolute;
  top: 110px;
  width: 200px;
  z-index: 100;
}

ul.dropdown-links li {
  border-bottom: solid 1px #505050;
}

ul.deepsea-submenu li a {
  color: #192b6c;
}

ul.deepsea-submenu li:hover {
  font-weight: bold;
}

ul.seescan-submenu li:hover {
  background-color: #8e8e8e;
}

ul.dropdown-links li a {
  height: unset;
  padding: 10px 20px;
  text-align: left;
}

ul.dropdown-links li:hover a:hover {
  border: none;
  color: white;
}
</style>
